import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Text, makeStyles, shorthands, tokens, typographyStyles } from '@fluentui/react-components';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalL),
  },
  targetName: {
    ...typographyStyles.body1Strong,
  },
  targetList: {
    ...typographyStyles.body1,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    ...shorthands.overflow('hidden'),
  },
});

const SingleTargeting = ({ category, targets = [] }) => {
  const classes = useStyles();
  const formattedTargets = useMemo(() => targets.join(', '), [targets]);

  if (targets.length === 0) {
    return null;
  }

  return (
    <div>
      <Text className={classes.targetName} block>
        {category}
      </Text>
      <Text className={classes.targetList} block title={formattedTargets}>
        {formattedTargets}
      </Text>
    </div>
  );
};

SingleTargeting.propTypes = {
  category: PropTypes.string.isRequired,
  targets: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export const AudienceTargeting = ({
  companyNames,
  companyIndustries,
  jobSeniorities,
  jobTitles,
  jobFunctions,
}) => {
  const i18n = useContext(I18nContext);
  const classes = useStyles();

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Audience') }}>
      <div className={classes.root}>
        <SingleTargeting
          category={i18n.getString(_TL_('Company'))}
          targets={companyNames}
        />
        <SingleTargeting
          category={i18n.getString(_TL_('Industry'))}
          targets={companyIndustries}
        />
        <SingleTargeting
          category={i18n.getString(_TL_('Job seniority'))}
          targets={jobSeniorities}
        />
        <SingleTargeting
          category={i18n.getString(_TL_('Job function'))}
          targets={jobFunctions}
        />
        <SingleTargeting
          category={i18n.getString(_TL_('Job title'))}
          targets={jobTitles}
        />
      </div>
    </PropertyRow>
  );
};

AudienceTargeting.propTypes = {
  companyNames: PropTypes.arrayOf(PropTypes.string),
  companyIndustries: PropTypes.arrayOf(PropTypes.string),
  jobSeniorities: PropTypes.arrayOf(PropTypes.string),
  jobTitles: PropTypes.arrayOf(PropTypes.string),
  jobFunctions: PropTypes.arrayOf(PropTypes.string),
};

AudienceTargeting.defaultProps = {
  companyNames: [],
  companyIndustries: [],
  jobSeniorities: [],
  jobTitles: [],
  jobFunctions: [],
};

